import { ICianMFUIElement } from '@cian/mf-registry/browser';
import * as React from 'react';
import { useApplicationContext } from 'shared/containers/ApplicationContext';

export function useMicrofrontEvents(
  microfrontendRef: React.RefObject<ICianMFUIElement | null>,
  isReady: boolean,
  onClose?: () => void,
) {
  const { eventQueue } = useApplicationContext();
  const [isHidden, setIsHidden] = React.useState(false);

  const handleStub = React.useCallback(() => setIsHidden(true), []);
  const handleError = React.useCallback(() => setIsHidden(true), []);
  const handleClose = React.useCallback(() => {
    setIsHidden(true);
    onClose?.();
  }, [onClose]);

  React.useEffect(() => {
    if (!microfrontendRef.current?.instance || !isReady) {
      return;
    }

    const instanceId = microfrontendRef.current.instance.id;

    eventQueue.on(`ad-banner-frontend-reporting.v1.${instanceId}.ad-banner-stub`, handleStub);
    eventQueue.on(`ad-banner-frontend-reporting.v1.${instanceId}.ad-banner-error`, handleError);
    eventQueue.on(`ad-banner-frontend-reporting.v1.${instanceId}.ad-banner-close`, handleClose);

    return () => {
      eventQueue.off(`ad-banner-frontend-reporting.v1.${instanceId}.ad-banner-stub`, handleStub);
      eventQueue.off(`ad-banner-frontend-reporting.v1.${instanceId}.ad-banner-error`, handleError);
      eventQueue.off(`ad-banner-frontend-reporting.v1.${instanceId}.ad-banner-close`, handleClose);
    };
  }, [eventQueue, handleStub, handleError, handleClose, microfrontendRef, isReady]);

  return { isHidden };
}
